<!--
 * @Author: linrui
 * @Date: 2021-12-20 14:12:06
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-04 11:28:39
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/doctorLogin.vue
-->
<template>
  <div class="doctor-doclogin">
    <div class="uc-box3">
      <div class="hd" id="myform">
        <div class="uc-hd-bg" :style="'background-image: url(' + kv + '); height:0; padding-top: 50%;'"></div>

        <template v-if="!showIsErecipel">
          <van-cell-group :border="false">
            <van-field v-model.trim="name" placeholder="请输入姓名" />
            <van-field v-model.trim="idsn" placeholder="请输入身份证号码" :error="showIdsnErrorStyle" @blur="handleIdsnCheck" keyboard="number" />
            <p class="errorCheckMsg" v-show="showIdsnErrorStyle">{{ idsnErrorMsg }}</p>
            <van-field maxlength="11" v-model.trim="mobile" :error="showMobileErrorStyle" placeholder="请输入手机号码" keyboard="number" @blur="handleMobileCheck" />
            <p class="errorCheckMsg" v-show="showMobileErrorStyle">{{ mobileErrorMsg }}</p>
            <van-field class="verifybtn" maxlength="6" v-model.trim="verifycode" :error="showVerifycodeErrorStyle" placeholder="输入验证码" keyboard="number" @blur="handleVerifycodeCheck">
              <template #button>
                <van-button class="form-btn" slot="right" :disabled="btnDisabled" @click.native="sendVerifycode">{{ btnText }}</van-button>
              </template>
            </van-field>
            <p class="errorCheckMsg" v-show="showVerifycodeErrorStyle">{{ verifycodeErrorMsg }}</p>
          </van-cell-group>
          <div class="btn">
            <van-button class="up" style="border-radius:99px;" @click.native="check()" :disabled="submitDisabled">登录/注册</van-button>
          </div>
          <PolicyPopup v-if="isPrivacyOpen" ref="policyPopupRef" v-model="checkedPrivacy" :policy-content="privacyConfig.privacy_policy" @has-read="handleHasRead" @confirm-policy="handleConfirmPolicy" />
        </template>

        <div v-if="showIsErecipel" class="is-erecipel-box">
          <div class="icon-box">
            <van-icon name="checked" color="#2AA7B0" size="65px" />
          </div>
          <p class="guide-info">经查询您已经成为“医师公益平台”的平台医生，是否在后续申请中采用平台医生已有信息？</p>
          <p class="erecipel-intro">医师公益平台是一个方便医生统一线上认证，远程签署医生备忘录，医生认证信息上链、方便信息共享的平台，成为平台医生后可便捷申请多个项目。</p>
          <div class="btn">
            <van-row>
              <van-col span="24">
                <van-button class="up" @click="adoptedErecipelInfo">好的，同意采用</van-button>
              </van-col>
              <van-col span="24">
                <van-button class="back" @click="rewriteDoctorInfo">不了，重新填写</van-button>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import kv from '@/assets/kv.png'
import { DoctorLogin, SyncErecipelDoctor, SendDocVerifycode, getPrivacyConfig, privacyReadDoc } from '../../api/api'
import { mapMutations } from 'vuex'
import { isIdCardNo, checkCellphone, checkVerifycode } from '../../utils/utils'
export default {
  name: 'DoctorLogin',
  data() {
    return {
      showIsErecipel: false, //是否是医师公益平台注册医生
      kv: kv, //主kv图
      name: '', //输入的用户姓名
      idsn: '', //输入的身份证号
      mobile: '', //手机号
      verifycode: '', //验证码
      btnText: '获取验证码', //验证码按钮文本
      timer: null,
      btnDisabled: false, //禁用验证码按钮
      submitDisabled: false, //是否禁用提交按钮
      doctor_id: '', //医生ID
      showIdsnErrorStyle: false, //身份证错误样式
      showMobileErrorStyle: false, //手机号错误样式
      showVerifycodeErrorStyle: false, //验证码错误样式
      idsnErrorMsg: '', //身份证错误信息
      mobileErrorMsg: '', //手机号错误信息
      verifycodeErrorMsg: '', //验证码错误信息
      checkedPrivacy: false, // 隐私政策勾选
      privacyConfig: {}, // 隐私政策配置
      hasReadPolicy: false // 是否阅读隐私政策
    }
  },
  computed: {
    isPrivacyOpen() {
      return this.privacyConfig.is_privacy_open === '1'
    }
  },

  created() {
    getPrivacyConfig()
      .then(res => {
        console.log(res, 'res')
        this.privacyConfig = res.data
      })
      .catch(err => {
        this.$toast(err.response.data.message)
      })
  },

  methods: {
    ...mapMutations(['setDoctorInfo', 'setHasEre']),

    //发验证码
    sendVerifycode() {
      if (!this.mobile) {
        this.$toast('请输入手机号码')
        return false
      } else if (!checkCellphone(this.mobile)) {
        this.$toast('请输入正确的手机号码')
        return false
      } else {
        this.btnDisabled = true
        this.$toast.loading({
          duration: 0,
          forbidClick: true
        })
        SendDocVerifycode({
          mobile: this.mobile,
          SmsType: '3'
        })
          .then(res => {
            this.startTimer()
          })
          .catch(error => {
            console.log(error)
            this.$toast.clear()
            this.btnDisabled = false
            this.$toast(error.response.data.message)
          })
      }
    },

    startTimer() {
      let seconds = 60
      this.$toast.clear()
      this.timer = setInterval(() => {
        seconds--
        this.btnText = seconds + '秒'
        if (seconds <= 0) {
          clearInterval(this.timer)
          this.btnText = '重发验证码'
          this.btnDisabled = false
        }
      }, 1000)
    },

    //处理手机号错误
    handleMobileCheck(e) {
      if (e.target.value) {
        if (!checkCellphone(e.target.value)) {
          this.showMobileErrorStyle = true
          this.mobileErrorMsg = '手机号码格式有误'
        } else {
          this.showMobileErrorStyle = false
          this.mobileErrorMsg = ''
        }
      } else {
        this.showMobileErrorStyle = false
        this.mobileErrorMsg = ''
      }
    },

    //处理手机号错误
    handleIdsnCheck(e) {
      if (e.target.value) {
        if (!isIdCardNo(e.target.value)) {
          this.showIdsnErrorStyle = true
          this.idsnErrorMsg = '身份证号码格式有误'
        } else {
          this.showIdsnErrorStyle = false
          this.idsnErrorMsg = ''
        }
      } else {
        this.showIdsnErrorStyle = false
        this.idsnErrorMsg = ''
      }
    },

    //处理验证码错误
    handleVerifycodeCheck(e) {
      if (e.target.value) {
        if (!checkVerifycode(e.target.value)) {
          this.showVerifycodeErrorStyle = true
          this.verifycodeErrorMsg = '无效验证码'
        } else {
          this.showVerifycodeErrorStyle = false
          this.verifycodeErrorMsg = ''
        }
      } else {
        this.showVerifycodeErrorStyle = false
        this.verifycodeErrorMsg = ''
      }
    },

    handleHasRead() {
    //   this.checkedPrivacy = true
      this.hasReadPolicy = true
    },
    handleConfirmPolicy() {
      this.check()
      this.$refs.policyPopupRef.closePolicyPopup()
    },

    //用户登陆或者注册
    check() {
      this.submitDisabled = true
      if (!this.name || !this.idsn) {
        this.$toast('请完善信息')
        this.submitDisabled = false
        return
      } else if (!isIdCardNo(this.idsn)) {
        //验证身份证号
        this.$toast('请输入正确的身份证号')
        this.submitDisabled = false
        return
      } else {
        if (!this.verifycode) {
          this.submitDisabled = false
          this.$toast('验证码不能为空')
          return
        }
        if (!checkVerifycode(this.verifycode)) {
          this.submitDisabled = false
          this.$toast('请输入正确的验证码')
          return
        }
      }
      if (this.isPrivacyOpen) {
        if (!this.hasReadPolicy) {
          this.$refs.policyPopupRef.openPolicyPopup()
          return
        }
        if (!this.checkedPrivacy) {
          this.$toast('请勾选“我已阅读并同意《隐私政策》”')
          return
        }
      }
      DoctorLogin({
        name: this.name,
        idsn: this.idsn,
        mobile: this.mobile,
        verifycode: this.verifycode
      })
        .then(async res => {
          this.setDoctorInfo(res.data.doctor)
          this.setHasEre(res.data.hasErecipelDoctor)
          this.doctor_id = res.data.doctor.id
          if (this.isPrivacyOpen) {
            await privacyReadDoc({
              doctor_id: this.doctor_id
            })
          }
          if (res.data && res.data.hasErecipelDoctor) {
            if (res.data.doctor && !res.data.doctor.status) {
              if (res.data.doctor.hospital) {
                this.$router.replace({
                  name: 'DoctorQuery'
                })
              } else {
                this.showIsErecipel = true
              }
              return
            } else {
              if (res.data.doctor.hospital) {
                this.$router.replace({
                  name: 'DoctorQuery'
                })
              } else {
                this.$router.replace({
                  name: 'DoctorReg',
                  query: {
                    isAdopted: true
                  }
                })
              }
            }
          } else {
            console.log(res.data, '医生信息')
            if (res.data.doctor.hospital) {
              this.$router.replace({
                name: 'DoctorQuery'
              })
            } else {
              this.$router.replace({
                name: 'DoctorReg',
                query: {
                  isAdopted: false
                }
              })
            }
            // this.$router.replace({
            //     name:'DoctorQuery'
            // })
          }
          this.submitDisabled = false
        })
        .catch(err => {
          this.submitDisabled = false
          this.$toast(err.response.data.message)
        })
    },

    //同意采用意师公益平台的医生信息
    adoptedErecipelInfo() {
      SyncErecipelDoctor({
        id: this.doctor_id,
        sync: 1
      })
        .then(res => {
          this.$router.replace({
            name: 'DoctorReg',
            query: {
              isAdopted: true
            }
          })
        })
        .catch(err => {
          this.$toast(err.response.data.message)
        })
    },

    //重新填写医生信息
    rewriteDoctorInfo() {
      this.$router.replace({
        name: 'DoctorReg',
        query: {
          isAdopted: false
        }
      })
    }
  }
}
</script>

<style lang="less">
// @import "~vux/src/styles/weui/widget/weui-agree/weui-agree";
// @import "~vux/src/styles/weui/widget/weui_page/weui_article";
@import '~@/style/base.less';

.doctor-doclogin {
  height: 100%;
  background: #fff;
  .van-cell-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    .van-cell {
      padding: 8px 16px;
    }
    .van-field {
      width: 90%;
      margin-top: 12px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 50px;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.3);
      .van-field__value {
        .van-field__body {
          .van-field__control {
            height: 30px;
            // color:rgba(178,178,178,.3);
            &::placeholder {
              color: rgba(178, 178, 178, 1);
            }
          }
        }
      }
      &:first-child {
        margin-top: 0;
      }
    }
    .van-field--error {
      border-color: #ff4830;
      .van-field__value {
        display: flex;
        justify-content: space-between;
        .van-field__body {
          .van-field__control {
            color: #323233;
            &::placeholder {
              color: rgba(178, 178, 178, 1);
            }
          }
        }
        .van-field__error-message {
          min-width: 108px;
          line-height: 30px;
          font-size: 12px;
          color: #ff4830;
        }
      }
    }
    .verifybtn {
      &.van-field--error {
        .van-field__value {
          position: relative;
          display: block;
          .van-field__error-message {
            position: absolute;
            top: 0;
            left: 80px;
            line-height: auto;
          }
        }
      }
      .form-btn {
        height: auto;
        padding: 4px 10px;
        background-color: #33c78e;
        border-color: #33c78e;
        font-size: 14px;
        color: #fff;
        border-radius: 4px;
      }
    }
  }
  .btn {
    margin-top: 20px;
    .up {
      height: 48px;
      font-size: 14px;
    }
  }
  .uc-hd-bg {
    width: 100%;
    background: top center no-repeat;
    background-size: cover;
  }
}

.errorCheckMsg {
  width: 90%;
  margin: 5px auto 0;
  padding: 0 16px;
  color: #ff4830;
}

.is-erecipel-box {
  padding: 16px;
  .icon-box {
    margin-bottom: 17px;
    text-align: center;
  }
  .guide-info {
    padding: 0 30px;
    margin-bottom: 15px;
    color: rgba(0, 0, 0, 0.8);
    font-size: 15px;
    text-indent: 20px;
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: PingFangSC-Medium;
  }
  .erecipel-intro {
    margin-bottom: 36px;
    padding: 0 30px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.6);
    text-indent: 20px;
    text-align: justify;
    text-justify: inter-ideograph;
    font-family: PingFangSC-Regular;
  }
  .btn {
    padding: 0 45px;
    .van-button {
      height: 45px;
      border-radius: 22px;
      font-size: 16px;
    }
    .up {
      margin-bottom: 16px;
    }
    .back {
      border-color: @theme-color;
      color: @theme-color;
    }
  }
}
</style>
